import { getProductVariantKey } from '../../../../../store/helpers/assets/aggregateProductVariants';

export const getAffectedAssetIds = (selectedAssetItems = [], productVariant) => {
  const key = getProductVariantKey(productVariant);
  const isListing = productVariant.type === 'listingVariant';
  const isDraft = productVariant.isDraft === true;

  return selectedAssetItems
    .filter((asset) => (
      (asset.productVariants || []).some((link) => {
        if (getProductVariantKey(link) !== key) return false;
        if (!isListing) return true;
        return (link.isDraft === true) === isDraft;
      })
    ))
    .map(({ _id }) => _id);
};

export const getAffectedAssetIdsForProduct = (
  selectedAssetItems = [],
  productLink,
  { isMaster = true } = {},
) => {
  const productId = String(productLink._id);

  if (isMaster) {
    return selectedAssetItems
      .filter((asset) => (
        (asset.products || []).some((link) => String(link._id) === productId)
      ))
      .map(({ _id }) => _id);
  }

  const isDraft = productLink.isDraft === true;

  return selectedAssetItems
    .filter((asset) => {
      const hasGallery = (asset.products || []).some(
        (link) => String(link._id) === productId && (link.isDraft === true) === isDraft,
      );
      const hasVariant = (asset.productVariants || []).some(
        (link) => link.type === 'listingVariant'
          && String(link.productId) === productId
          && (link.isDraft === true) === isDraft,
      );
      return hasGallery || hasVariant;
    })
    .map(({ _id }) => _id);
};

export const getListingVariantIdsForAssets = (assetItems = [], listingId, isDraft) => {
  const ids = new Set();

  assetItems.forEach((asset) => {
    (asset.productVariants || []).forEach((link) => {
      if (link.type === 'listingVariant'
        && String(link.productId) === String(listingId)
        && (link.isDraft === true) === isDraft) {
        ids.add(link.variantId);
      }
    });
  });

  return [...ids];
};

export const buildDetachTargets = (productVariant) => {
  if (productVariant.type === 'listingVariant') {
    return {
      listings: [{
        listingId: productVariant.productId,
        listingVariantIds: [productVariant.variantId],
        listingGallery: false,
        isDraft: productVariant.isDraft !== false,
      }],
    };
  }

  return {
    masterVariantIds: [productVariant.variantId],
  };
};

export const buildListingProductDetachTargets = ({
  listingId,
  channelId,
  assetItems,
  isDraft,
  listingGallery = isDraft,
}) => ({
  listings: [{
    channelId,
    listingId,
    isDraft,
    listingGallery,
    listingVariantIds: getListingVariantIdsForAssets(assetItems, listingId, isDraft),
  }],
});
